import React, { FC } from 'react'

import { config } from 'lib/config'
import { ConfirmationDialog } from 'components/dialog/ConfirmationDialog'

import styles from './PrivacyPolicyModalView.module.scss'

interface Props {
  isOpen: boolean
  handleHide: () => void
}

export const PrivacyPolicyModalView: FC<Props> = ({ isOpen, handleHide }) => {
  const iframeUrl = `https://${config.API_BASE_URL}/privacypolicy.html`

  return (
    <ConfirmationDialog
      onConfirm={() => {}}
      show={isOpen}
      onHide={handleHide}
      className={styles.privacyPolicyModal}
      isConfirmButtonShown={false}
      discardBtnLabel="Close"
      title="Privacy Policy"
      buttonSize="big">
      <iframe src={iframeUrl} frameBorder="0" height="460" width="100%" title="Privacy Policy" />
    </ConfirmationDialog>
  )
}
